/**
 * @generated SignedSource<<8194f9bed5a1d942f1c73da9113fd1ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LabelEditForm_label$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "LabelEditForm_label";
};
export type LabelEditForm_label$key = {
  readonly " $data"?: LabelEditForm_label$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabelEditForm_label">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LabelEditForm_label",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Label",
  "abstractKey": null
};

(node as any).hash = "22aa269009ede574cafd800a0793bd22";

export default node;
